var Form = {
	init: function () {
		this.sendForm();
	},
	sendForm: function(){
		$('.form-ajax').each(function (i, elt) {
			$(elt).on('submit', function(ev){

				ev.preventDefault();
				var formData = new FormData(this);

				$.ajax({
					url: ajaxurl,
					type: 'POST',
					data: formData,
					success: function (data) {
						var _data = JSON.parse(data);
						$(".form-response .text").html(_data.message);
						$(".formulaire-container").addClass("hidden");
						$(".form-response").addClass("displayed");
						setTimeout(function () {
							$(".form-response").addClass("visible");
						}, 40);

					},
					cache: false,
					contentType: false,
					processData: false
				});

			});
		});
	},
};
$(window).load(function(){
	if($(".form-ajax").length){
		Form.init();
	}
});